import React, { useState, createContext } from "react";
import ticketData from "./ticketData";

export const TicketContext = createContext();

export const TicketContextProvider = (props) => {
    const [data, setData] = useState(ticketData);

    return <TicketContext.Provider value={{contextData: [data, setData]}}>{props.children}</TicketContext.Provider>
}